import { APP_BUNDLES, EXAM_TITLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY } from './_shared/brand-data'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_AIGP,
  PRACTICE_TEST as PRACTICE_TEST_AIGP,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_AIGP,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_AIGP,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_AIGP,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_AIGP,
} from './aigp'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_AWSCAIP,
  PRACTICE_TEST as PRACTICE_TEST_AWSCAIP,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_AWSCAIP,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_AWSCAIP,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_AWSCAIP,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_AWSCAIP,
} from './awscaip'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_AWSMLE,
  PRACTICE_TEST as PRACTICE_TEST_AWSMLE,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_AWSMLE,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_AWSMLE,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_AWSMLE,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_AWSMLE,
} from './awsmle'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_GHCPC,
  PRACTICE_TEST as PRACTICE_TEST_GHCPC,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_GHCPC,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_GHCPC,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_GHCPC,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_GHCPC,
} from './ghcpc'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SECAIPLUS,
  PRACTICE_TEST as PRACTICE_TEST_SECAIPLUS,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SECAIPLUS,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SECAIPLUS,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SECAIPLUS,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_SECAIPLUS,
} from './secaiplus'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_DATAAI,
  PRACTICE_TEST as PRACTICE_TEST_DATAAI,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_DATAAI,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_DATAAI,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_DATAAI,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_DATAAI,
} from './dataai'

import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

export { APP_BUNDLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY }

export const APP_DATA = {
  DISPLAY_APP_NAME: 'AICerts Exam Prep',
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'AIGP';
};

// Full cert name (exam_full_name) for the web page header. Mobile's counterpart
// deliberately returns the short vendor-prefixed exam_name — the full name wraps
// to two lines under the logo (tried 2026-08-01) — so don't "unify" them.
export const GET_EXAM_DISPLAY_TITLE = (SELECTED_BUNDLE) => {
  const bundle = APP_BUNDLES.find(b => b.key === SELECTED_BUNDLE);
  return bundle?.exam_full_name || bundle?.title || EXAM_TITLES[SELECTED_BUNDLE] || 'AIGP';
};

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  const bundle = APP_BUNDLES.find(b => b.key === result);
  return bundle ? bundle.bundle_firebase_collection_name : 'AIGP';
};

const QUESTION_VERSIONS = {
  aigp: QUESTION_VERSION_OF_JSON_AIGP,
  awscaip: QUESTION_VERSION_OF_JSON_AWSCAIP,
  awsmle: QUESTION_VERSION_OF_JSON_AWSMLE,
  ghcpc: QUESTION_VERSION_OF_JSON_GHCPC,
  secaiplus: QUESTION_VERSION_OF_JSON_SECAIPLUS,
  dataai: QUESTION_VERSION_OF_JSON_DATAAI,
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  return QUESTION_VERSIONS[result] || QUESTION_VERSION_OF_JSON_AIGP;
};

export const app_url = "https://www.learnzapp.com/apps/aicerts";

const PRACTICE_TESTS = {
  aigp: PRACTICE_TEST_AIGP,
  awscaip: PRACTICE_TEST_AWSCAIP,
  awsmle: PRACTICE_TEST_AWSMLE,
  ghcpc: PRACTICE_TEST_GHCPC,
  secaiplus: PRACTICE_TEST_SECAIPLUS,
  dataai: PRACTICE_TEST_DATAAI,
};

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  return PRACTICE_TESTS[SELECTED_BUNDLE] || PRACTICE_TEST_AIGP;
};

const DOMAIN_LISTS = {
  aigp: APP_DOMAIN_LIST_AIGP,
  awscaip: APP_DOMAIN_LIST_AWSCAIP,
  awsmle: APP_DOMAIN_LIST_AWSMLE,
  ghcpc: APP_DOMAIN_LIST_GHCPC,
  secaiplus: APP_DOMAIN_LIST_SECAIPLUS,
  dataai: APP_DOMAIN_LIST_DATAAI,
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  return DOMAIN_LISTS[SELECTED_BUNDLE] || APP_DOMAIN_LIST_AIGP;
};

const STUDY_QUESTION_MENUS = {
  aigp: GET_STUDY_QUESTION_MENU_AIGP,
  awscaip: GET_STUDY_QUESTION_MENU_AWSCAIP,
  awsmle: GET_STUDY_QUESTION_MENU_AWSMLE,
  ghcpc: GET_STUDY_QUESTION_MENU_GHCPC,
  secaiplus: GET_STUDY_QUESTION_MENU_SECAIPLUS,
  dataai: GET_STUDY_QUESTION_MENU_DATAAI,
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  const menuFn = STUDY_QUESTION_MENUS[SELECTED_BUNDLE] || GET_STUDY_QUESTION_MENU_AIGP;
  let menu = menuFn();

  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Questions (Testing)',
      key: 'all_questions_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

const FLASH_CARD_MENUS = {
  aigp: GET_FLASH_CARD_MENU_AIGP,
  awscaip: GET_FLASH_CARD_MENU_AWSCAIP,
  awsmle: GET_FLASH_CARD_MENU_AWSMLE,
  ghcpc: GET_FLASH_CARD_MENU_GHCPC,
  secaiplus: GET_FLASH_CARD_MENU_SECAIPLUS,
  dataai: GET_FLASH_CARD_MENU_DATAAI,
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  const menuFn = FLASH_CARD_MENUS[SELECTED_BUNDLE] || GET_FLASH_CARD_MENU_AIGP;
  return menuFn();
};

const ARTICLE_MENUS = {
  aigp: GET_ARTICLE_MENU_AIGP,
  awscaip: GET_ARTICLE_MENU_AWSCAIP,
  awsmle: GET_ARTICLE_MENU_AWSMLE,
  ghcpc: GET_ARTICLE_MENU_GHCPC,
  secaiplus: GET_ARTICLE_MENU_SECAIPLUS,
  dataai: GET_ARTICLE_MENU_DATAAI,
};

export const GET_ARTICLE_MENU = (SELECTED_BUNDLE) => {
  const menuFn = ARTICLE_MENUS[SELECTED_BUNDLE] || GET_ARTICLE_MENU_AIGP;
  let menu = [...menuFn()]; // Create a new array to avoid mutation

  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Articles (Testing)',
      key: 'all_articles_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

/*** LEADING SCREEN TUTORIAL ARRAY ***/
export const GET_TUTORIALS = () => {
  return [
    {
      title: `AICerts - AI Certification Exam Prep`,
      image: IMAGES.slide_1,
      description:
        'Ace your AI certification exam on the first try with this comprehensive study app! \nPractice questions and flashcards for AIGP, CompTIA SecAI+, AWS AI Practitioner, AWS Machine Learning Engineer, and GitHub Copilot.',
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};

/** STRINGS */
export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for AI certification exams (AIGP, CompTIA SecAI+, AWS AI Practitioner, AWS Machine Learning Engineer, GitHub Copilot). I think you will find it very useful. Check it out " +
    app_url,
};

export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
};

// Display name for the Stripe product on user-facing invoices.
// Each brand build sets its own value (matches the product name in the Stripe dashboard).
export const STRIPE_PRODUCT_DISPLAY_NAME = 'AICerts App - AI Certification Exam Prep';

export const PAYWALL_COLUMNS = null;
export const IS_TEST_MODE = false;
export const IS_VISIBLE_COMMUNITY = true;

// Home smart-nudge continuation card — enabled for the aicerts bundle (all exams).
export const NUDGE_CARD_ENABLED = true;

// Metered article unlocks — 5 permanent unlocks per DAY (any domain, UTC
// midnight reset) for free users, replacing the legacy
// first-num_articles-per-domain cap. See docs/ARTICLES_METERING_GUIDE.md.
export const METERED_ARTICLE_UNLOCKS = 5;
export const METERED_ARTICLE_PERIOD = 'day';

// Post-sign-in welcome modal title (web twin of mobile WELCOME_DETAILS.welcomeModalTitle;
// title matches the mobile brand config so the greeting is identical cross-platform).
export const WELCOME_DETAILS = {
    welcomeModalTitle: 'Welcome to AI Certs Prep!',
};
